<div class="min-h-full">
    <nav class="bg-gray-800 sticky top-0 z-[9999]" *ngIf="isLoggedIn">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="flex h-16 items-center justify-between">
          <div class="flex items-center">
            <div class="flex-shrink-0" [ngClass]="{
                'hidden': user === null,
                '': user !== null
              }">
              <img class="h-10 w-auto cursor-pointer" 
                   src="/assets/Buziflow-Logo750.gif" 
                   alt="Buziflow" 
                   [routerLink]="user?.roles?.includes('vendor') ? '/vdashboard' : '/dashboard'"> 
                   <!-- <span class="block text-xs text-gray-400 font-mono text-center select-none" style="user-select: none;">
                    v{{ appVersion }}
                  </span> -->
            </div>
            <div class="hidden md:block">
              
              
              <div class="ml-10 flex items-baseline space-x-4" [ngClass]="{
                'hidden': user === null || user.roles[0] === 'tech',
                '': user !== null
              }">
              <a routerLink="/dashboard" 
              routerLinkActive="bg-gray-300 text-gray-900"
              [routerLinkActiveOptions]="{exact: true}"
              *ngIf="user?.roles.includes('admin') || user?.roles.includes('gm')|| user?.roles.includes('developer') || user?.roles.includes('estimator')" 
              class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">Requests</a> 
         
              <!-- <a routerLink="/team" 
                  routerLinkActive="bg-gray-300 text-gray-900"
                  *ngIf="user?.roles.includes('tech') || user?.roles.includes('developer')" 
                  class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">Daily Tech Q&A (Preview)</a> -->
            
              <!-- <a *ngIf="user?.roles.includes('developer')" 
                  routerLinkActive="bg-gray-300 text-gray-900"
                  class="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white cursor-pointer">Calendar</a> -->
            
              <a routerLink="/am-dashboard"
                 routerLinkActive="bg-gray-300 text-gray-900"
                 [routerLinkActiveOptions]="{exact: true}"
                 *ngIf="user?.roles.includes('am')"
                 class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">Market Area Dashboard</a>

                 <a routerLink="/vendor-tasks" 
                 routerLinkActive="bg-gray-300 text-gray-900"
                 [routerLinkActiveOptions]="{exact: true}"
                 *ngIf="user?.roles.includes('gm')|| user?.roles.includes('developer') || user?.roles.includes('estimator')" 
                 class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">Sublets</a> 
                
                <!-- <a *ngIf="user?.roles.includes('developer')" class="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white cursor-pointer" routerLink="/admin">Admin</a> -->
                 <!-- Mobile GM Admin Menu -->
              <!-- Desktop GM Admin Dropdown -->
                <div class="relative" *ngIf="user?.roles.includes('gm') || user?.roles.includes('admin') || user?.roles.includes('developer')" #dropdowngmadmin>
                  <a (click)="toggleDropDownGMAdmin()" 
                    [ngClass]="{
                      'bg-gray-300 text-gray-900': isGMAdminRouteActive(),
                      'text-gray-300': !isGMAdminRouteActive()
                    }"
                    class="rounded-md px-3 py-2 cursor-pointer text-sm font-medium hover:bg-gray-700 hover:text-white">
                    Admin
                  </a>

                  <!-- GM Admin Dropdown Menu -->
                  <div *ngIf="gmAdminDropdown && !user?.roles.includes('vendor')" class="absolute bg-white shadow-lg rounded-md mt-2 z-10 w-64">
                    <a routerLink="/QandA" routerLinkActive="bg-gray-300 text-gray-900"
                      (click)="closeDropdownGMAdmin($event); toggleDropDownGMAdmin()" 
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900">
                      Daily Updates
                    </a>
                    <a *ngIf="!user?.roles.includes('vendor')" routerLink="/reports/day-end" routerLinkActive="bg-gray-300 text-gray-900"
                      (click)="closeDropdownGMAdmin($event); toggleDropDownGMAdmin()" 
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900">
                      Day End
                    </a>
                    <a *ngIf="!user?.roles.includes('vendor')" routerLink="/reports" routerLinkActive="bg-gray-300 text-gray-900"
                      (click)="closeDropdownGMAdmin($event); toggleDropDownGMAdmin()" 
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900">
                      Reports
                    </a> 
                    <a *ngIf="!user?.roles.includes('vendor')" routerLink="/vendor-approval" routerLinkActive="bg-gray-300 text-gray-900" 
                      (click)="closeDropdownGMAdmin($event); toggleDropDownGMAdmin()" 
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900">
                      Vendor Approval
                    </a>
                    <a *ngIf="!user?.roles.includes('vendor')" routerLink="/team" routerLinkActive="bg-gray-300 text-gray-900"
                      (click)="closeDropdownGMAdmin($event); toggleDropDownGMAdmin()" 
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900">
                      Team
                    </a>
                    
                  </div>
                </div>
              </div>
            </div>
            
          </div>
          <div class="hidden md:block">
            <div class="ml-4 flex items-center md:ml-6" [ngClass]="{
                'hidden': user === null,
                '': user !== null
              }">
              <!-- GM Location Switcher (GM Only) -->
              <div class="ml-0 mr-2" *ngIf="isGM">
                <app-gm-location-switcher></app-gm-location-switcher>
              </div>
              <lib-audio-indicator class="mr-2"></lib-audio-indicator>
              <app-notification class="hidden" aria-hidden="true"></app-notification>
              
              <!-- Profile dropdown -->
              <div class="relative ml-3">
                <div>
                  <button 
                  (click)="toggleDropdown()" 
                  (mouseenter)="openDropdown()"
                  type="button" 
                  class="relative flex max-w-xs items-center rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800" 
                  id="user-menu-button" 
                  aria-expanded="false" 
                  aria-haspopup="true">
                    <span class="absolute -inset-1.5"></span>
                    <span class="sr-only">Open user menu</span>
                    <div [ngClass]="getBackgroundColor(user?.name)" class="h-8 w-8 rounded-full flex items-center justify-center text-white">
                      {{ getInitials(user?.name) }}
                    </div>
                </button>
                </div>

                <div 
                #dropdownmenu 
                *ngIf="dropdownOpen" 
                (mouseleave)="closeDropdown()"
                id="user-dropdown-menu"
                class="dropdown-menu absolute right-0 z-[9999] mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none transition ease-out duration-100 transform opacity-100 scale-100" 
                role="menu" 
                aria-orientation="vertical" 
                aria-labelledby="user-menu-button" 
                tabindex="-1"
              >
                <a 
                  (click)="toggleDropdown()" 
                
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer" 
                  role="menuitem" 
                  tabindex="-1" 
                  id="user-menu-item-0" 
                  routerLink="profile"
                >Your Profile</a>
                <a *ngIf="!user?.roles.includes('vendor')"
                  (click)="toggleDropdown()" 
                  
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer" 
                  role="menuitem" 
                  tabindex="-1" 
                  id="user-menu-item-1" 
                  routerLink="settings"
                >Settings</a>
                <a 
                  (click)="logOut()" 
                 
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer" 
                  role="menuitem" 
                  tabindex="-1" 
                  id="user-menu-item-2"
                >Sign out</a>
              </div>
              </div>
              <div class="ml-3">
                <div class="text-base font-medium leading-none text-white">{{ user?.name }}</div>
                <div class="text-sm font-medium leading-none text-gray-400 mt-1">{{ user?.email}}</div>
                <div class="text-xs font-medium leading-none text-gray-400 mt-1.5">
                  <span>{{ tenantDetails || tenantAddress }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Mobile Menu View -->
          <div class="-mr-2 flex md:hidden">

            <div class="flex items-center px-5" [ngClass]="{
                'hidden': user === null,
                '': user !== null
              }">
              <lib-audio-indicator></lib-audio-indicator>
            
            <div class="flex-shrink-0 px-3">
                <div [ngClass]="getBackgroundColor(user?.name)" class="h-8 w-8 rounded-full flex items-center justify-center text-white">
                  {{ getInitials(user?.name) }}
                </div>
              </div>

            <button (click)="toggleMobileMenu()" type="button" class="relative inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800" aria-controls="mobile-menu" aria-expanded="false">
              <span class="absolute -inset-0.5"></span>
              <span class="sr-only">Open main menu</span>
              <svg class="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
              </svg>
              <svg class="hidden h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            </div>
          </div>
        </div>
      </div>
  
      <div class="md:hidden" id="mobile-menu" [ngClass]="{'block': mobileMenuOpen, 'hidden': !mobileMenuOpen}">
        <app-gm-location-switcher *ngIf="isGM"></app-gm-location-switcher>
        
        <div class="space-y-1 px-2 pb-3 pt-2 sm:px-3">
          <a (click)="toggleMobileMenu()" 
            class="cursor-pointer block rounded-md bg-gray-900 px-3 py-2 text-base font-medium text-white" 
            aria-current="page" 
            [routerLink]="user?.roles.includes('tech') ? '/mobile/new-task' : '/dashboard'">
            Requests
          </a>
          <a (click)="toggleMobileMenu()"  *ngIf="user?.roles.includes('tech') || user?.roles.includes('developer')" routerLink="/QandA" class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white">Daily Updates</a>
          <a (click)="toggleMobileMenu()" *ngIf="user?.roles.includes('admin') || user?.roles.includes('gm') || user?.roles.includes('developer')" routerLink="/team" class="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">Team</a>
         
          <a routerLink="/vendor-tasks" (click)="toggleMobileMenu()" 
            class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white cursor-pointer" 
            *ngIf="user?.roles.includes('gm') || user?.roles.includes('admin') || user?.roles.includes('estimator') || user?.roles.includes('developer')">
            Sublets
          </a>
         
          <a (click)="toggleMobileMenu()"
             routerLink="/am-dashboard"
             *ngIf="user?.roles.includes('am')"
             class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
            Market Area Dashboard
          </a>
          
          <div class="relative">
            <a (click)="toggleMobileAdminMenu()" 
               class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white flex items-center justify-between" 
               *ngIf="user?.roles.includes('developer')">
              <span>Admin</span>
              <svg [ngClass]="{'rotate-180': mobileAdminMenuOpen}" 
                   class="h-5 w-5 transition-transform duration-200" 
                   xmlns="http://www.w3.org/2000/svg" 
                   viewBox="0 0 20 20" 
                   fill="currentColor">
                <path fill-rule="evenodd" 
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" 
                      clip-rule="evenodd" />
              </svg>
            </a>
          
            <!-- Admin Submenu -->
            <div *ngIf="mobileAdminMenuOpen" 
                 class="pl-4 space-y-1 transition-all duration-200 ease-in-out">
              <a (click)="toggleMobileMenu(); toggleMobileAdminMenu()" 
                 routerLink="/team" 
                 class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                Team
              </a>
              <a (click)="toggleMobileMenu(); toggleMobileAdminMenu()" 
                 routerLink="/reports" 
                 class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                Reports
              </a>
              <a (click)="toggleMobileMenu(); toggleMobileAdminMenu()" 
                 routerLink="/vendor-approval" 
                 class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                Vendor Approval
              </a>
            </div>
          </div>

        </div>
        <div class="border-t border-gray-700 pb-3 pt-4">
          <div class="flex items-center px-5">
            <div class="flex-shrink-0">
              <div [ngClass]="getBackgroundColor(user?.name)" class="h-8 w-8 rounded-full flex items-center justify-center text-white">
                {{ getInitials(user?.name) }}
              </div>
            </div>
            <div class="ml-3">
              <div class="text-base font-medium leading-none text-white">{{ user?.name }}</div>
              <div class="text-sm font-medium leading-none text-gray-400">{{ user?.email }}</div>
            </div>
           
          </div>
          <div class="mt-3 space-y-1 px-2">
            <a (click)="toggleMobileMenu()" routerLink="profile" class="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white">Your Profile</a>
            <a *ngIf="!user?.roles.includes('vendor')" (click)="toggleMobileMenu()" routerLink="settings"  class="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white">Settings</a>
            <a (click)="logOut()" class="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white">Sign out</a>
          </div>
        </div>
    </div>
  </nav>
    <app-sound-permission-banner></app-sound-permission-banner>

<div [ngClass]="{ 'mt-0': !isLoggedIn, 'has-footer': isLoggedIn }" class="main-content">
  <router-outlet></router-outlet>
</div>

<lib-reminder-overlay></lib-reminder-overlay>

<lib-image-viewer [topOffset]="60"></lib-image-viewer>

<footer *ngIf="isLoggedIn" class="w-full bg-gray-800 text-gray-300 text-center py-2 text-xs fixed bottom-0 left-0 z-50 shadow-inner">
  Wayne B Tech Innovations, LLC &copy; 2025 &mdash; v{{ appVersion }}
</footer>

